import { styled } from "styled-components";

export const WhatIDoWrapper = styled.div`
padding-top: 124px;
padding-bottom: 176px;
background-color: #fff;

.what-i-do .card-img-top {
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    height: auto;
    padding:20px;
}

.card-body {
    background: #000;

    p {
        color: #fff;
    }
}

@media (max-width: 776px) {
.cta-primary {
    margin-bottom: 40px;
    position: relative;
}
}

`